<template>
  <div>
    <h3 style="text-align: center;"><b>DANH SÁCH NHÂN THÂN NHÂN VIÊN</b></h3>
    <h4 style="text-align: center;">đến ngày {{new Date() | moment('DD/MM/YYYY')}}</h4>
    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      small
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(namsinh)="data">{{formatDate(data.value)}}</template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Report3",
  data() {
    return {
      fields: [
        {
          key: "manhanvien",
          label: "Mã NV",
          sortable: true,
          thClass: "align-middle",
          thStyle: {width: "80px", textAlign : "center"},
          // stickyColumn: true,
        },
         {
          key: "hovaten",
          label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "donvicongtacshort",
          label: "Đơn vị công tác",
          sortable: true,
          thClass: "align-middle",
          thStyle: {width: "120px", textAlign : "center"},
          tdClass: "text-center",
        },
        // {
        //   key: "phongbancongtacshort",
        //   label: "Phòng ban",
        //   sortable: true,
        //   thClass: "text-center",
        //   thStyle: {width: "130px"},
        // },
        {
          key: "vitricongviec",
          label: "Chức danh",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "thannhan_hovaten",
          label: "Họ tên thân nhân",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "thannhan_quanhe",
          label: "Quan hệ",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "thannhan_namsinh",
          label: "Năm sinh",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
          tdClass: "text-center",
        },
        {
          key: "thannhan_diachi",
          label: "Địa chỉ",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
        {
          key: "thannhan_dienthoai",
          label: "Số điện thoại",
          sortable: true,
          thClass: "align-middle",
          thStyle: {textAlign : "center"},
        },
      ],
      items: [],
      totalRow: null,
    };
  },
  // computed: {},
  created() {
    this.initData();
  },
 methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.report = 3;
      axios
        .get(`/api/employeereport/get`, { params: query })
        .then((response) => {
          this.items = response.data.items;
          this.totalRow = response.data.totalRow;
        })
        .catch((err) => {});
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
